<template>
<div class="container">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form>
        <div class="card ">
          <div class="card-header">
            <i class="fa fa-pencil"></i><strong>Configuração</strong><strong></strong>
          </div>
          <div class="card-block">
            <div class="form-group" :class="{'input': true, 'has-danger': errors.has('nome') }">
              <label class="col-form-label">Nome</label>
              <input type="text" name="nome" v-validate="'required'" v-model="configuration.name" class="form-control">

              <span v-show="errors.has('nome')" class="form-control-feedback">{{ errors.first('nome') }}</span>
            </div>
            <div class="form-group">
              <label lass="col-form-label">Labels</label>
              <v-select taggable multiple v-model="configuration.labels"></v-select>
            </div>
            <br/>
            <h6>Input</h6>
            <hr />
            <div class="row">
              <div class="form-group col-md-4">
                <label class="col-form-label">Nome</label>
                <select class="form-control" v-model="configuration.input.name">
                    <option value="rabbit-mq" selected>Rabbit-MQ</option>
                  </select>
              </div>
              <div class="form-group col-md-4" :class="{'input': true, 'has-danger': errors.has('virtual host') }">
                <label class="col-form-label">Virtual Host</label>
                <input type="text" class="form-control" name="virtual host" v-validate="'required'" v-model="configuration.input.virtualHost">
                <span v-show="errors.has('virtual host')" class="form-control-feedback">{{ errors.first('virtual host') }}</span>
              </div>
              <div class="form-group col-md-4" :class="{'input': true, 'has-danger': errors.has('fila') }">
                <label class="col-form-label">Fila</label>
                <input type="text" class="form-control" name="fila" v-validate="'required'" v-model="configuration.input.queue">
                <span v-show="errors.has('fila')" class="form-control-feedback">{{ errors.first('fila') }}</span>
              </div>
            </div>

            <div class="form-group" :class="{'input': true, 'has-danger': errors.has('hostname') }">
              <label class="col-form-label">Hostname</label>
              <input type="text" class="form-control" name="hostname" v-validate="'required'" v-model="configuration.input.hostname">
              <span v-show="errors.has('hostname')" class="form-control-feedback">{{ errors.first('hostname') }}</span>
            </div>

            <div class="row">
              <div class="form-group col-md-6" :class="{'input': true, 'has-danger': errors.has('usuário') }">
                <label class="col-form-label">Usuário</label>
                <input type="text" class="form-control" name="usuário" v-validate="'required'" v-model="configuration.input.username">
                <span v-show="errors.has('usuário')" class="form-control-feedback">{{ errors.first('usuário') }}</span>
              </div>
              <div class="form-group col-md-6" :class="{'input': true, 'has-danger': errors.has('senha') }">
                <label class="col-form-label">Senha</label>
                <input type="password" class="form-control" name="senha" v-validate="'required'" v-model="configuration.input.password">
                <span v-show="errors.has('senha')" class="form-control-feedback">{{ errors.first('senha') }}</span>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-3" :class="{'input': true, 'has-danger': errors.has('connection timeout') }">
                <label class="col-form-label">ConnectionTimeout</label>
                <input type="number" class="form-control" name="connection timeout" v-validate="'required'" v-model="configuration.input.connectionTimeout">
                <span v-show="errors.has('connection timeout')" class="form-control-feedback">{{ errors.first('connection timeout') }}</span>
              </div>
              <div class="form-group col-md-3" :class="{'input': true, 'has-danger': errors.has('redeliver delay') }">
                <label class="col-form-label">RedeliverDelay</label>
                <input type="number" class="form-control" name="redeliver delay" v-validate="'required'" v-model="configuration.input.redeliverDelay">
                <span v-show="errors.has('redeliver delay')" class="form-control-feedback">{{ errors.first('redeliver delay') }}</span>
              </div>
              <div class="form-group col-md-3" :class="{'input': true, 'has-danger': errors.has('retry count') }">
                <label class="col-form-label">RetryCount</label>
                <input type="number" class="form-control" name="retry count" v-validate="'required'" v-model="configuration.input.retryCount">
                <span v-show="errors.has('retry count')" class="form-control-feedback">{{ errors.first('retry count') }}</span>
              </div>
              <div class="form-group col-md-3" :class="{'input': true, 'has-danger': errors.has('thread count') }">
                <label class="col-form-label">ThreadCount</label>
                <input type="number" class="form-control" name="thread count" v-validate="'required'" v-model="configuration.input.threadCount">
                <span v-show="errors.has('thread count')" class="form-control-feedback">{{ errors.first('thread count') }}</span>
              </div>
            </div>
            <br/>

            <div class="row">
              <div class="form-group col-md-6" :class="{'input': true, 'has-danger': errors.has('batchSize') }">
                <label class="col-form-label">Mensagens por lote</label>
                <input class="form-control" name="batchSize" v-validate="'required'" type="number" min="1" v-model="configuration.batchSize">
                <span v-show="errors.has('batchSize')" class="form-control-feedback">{{ errors.first('batchSize') }}</span>
              </div>
              <div class="form-group col-md-6" :class="{'input': true, 'has-danger': errors.has('timeout (s)') }">
                <label class="col-form-label">Timeout (s)</label>
                <input class="form-control" name="timeout (s)" v-validate="'required'" type="number" min="1" v-model="configuration.timeoutSeconds">
                <span v-show="errors.has('timeout (s)')" class="form-control-feedback">{{ errors.first('timeout (s)') }}</span>
              </div>
            </div>

            <h6>Schemas</h6>
            <hr />
            <b-card no-block>
              <b-tabs card>
                <b-tab :title="` Event: ${schema.name}`" v-for="(schema,index) in configuration.schemas" :key="index">
                  <div class="form-group" :class="{'input': true, 'has-danger': errors.has('nome do schema') }">
                    <label class="col-form-label">Nome</label>
                    <input type="text" name="nome do schema" v-validate="'required'" class="form-control" v-model="schema.name">
                    <span v-show="errors.has('nome do schema')" class="form-control-feedback">{{ errors.first('nome do schema') }}</span>
                  </div>

                  <div class="form-group" :class="{'input': true, 'has-danger': errors.has('content') }">
                    <label class="col-form-label">Conteúdo</label>
                    <textarea class="form-control" name="content" v-model="schema.content"></textarea>
                  </div>

                  <div class="form-group">
                    <label for="inputUrl" class="col-form-label">Agrupador por</label>
                    <div v-for="(path, index) in schema.groupedBy" v-bind:key="index">
                      <div class="input-group">
                        <input type="text" class="form-control col-md-6" placeholder="Json Path" v-model="schema.groupedBy[index]">
                        <button type="button" v-on:click="removeJsPathFromSchema(schema, path)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>
                        <button type="button" v-on:click="addJsPathToSchema(schema)" :disabled="index !== (schema.groupedBy.length - 1)" class="btn btn-sm btn-default">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" :class="{'input': true, 'has-danger': errors.has('template') }">
                    <label class="col-form-label">
                      <b-popover :triggers="['hover']">
                        Template <span  variant="primary"><i class="fa fa-question-circle"></i></span>
                        <span slot="content">
                          Os lotes serão agrupados utilizando a variável <strong>messages</strong>.
                        </span>
                      </b-popover>
                    </label>
                    <textarea class="form-control" name="template" v-validate="'required'" v-model="schema.template"></textarea>
                    <span v-show="errors.has('template')" class="form-control-feedback">{{ errors.first('template') }}</span>
                  </div>
                  <hr />
                  <div class="form-group">
                    <label lass="col-form-label">Webhooks</label>
                    <v-select multiple :options="webhooks" v-model="schema.webhooks"></v-select>
                  </div>
                  <div>
                    <b-btn size="sm" variant="danger" v-show="index > 0" class="float-right" @click="()=>closeTab(index)"><i class="fa fa-trash"></i></b-btn>
                  </div>
                </b-tab>
                <b-nav-item slot="tabs" @click.prevent="newTab" href="#">
                  <i class="fa fa-plus"></i>
                </b-nav-item>
                <div slot="empty" class="text-center text-muted">
                  Não há schemas cadastrados
                  <br> Abra uma nova aba clicando no botão +.
                </div>
              </b-tabs>
            </b-card>
            <hr />
          </div>
          <div class="card-footer">
            <div class="pull-right">
              <router-link :to="'/rocket/configurations'" class="btn btn-sm">
                <i class="fa fa-chevron-left"></i> Cancelar
              </router-link>
              <button type="submit" @click.prevent="saveConfiguration" class="btn btn-sm btn-secondary"><i class="fa fa-save"></i> Salvar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'

export default {
  name: 'configuration',
  components: {
    vSelect
  },
  data() {
    return {
      name: '',
      configuration: {
        id: '',
        labels: [],
        input: {
          name: 'rabbit-mq',
          virtualHost: '',
          queue: '',
          hostname: '',
          username: '',
          password: '',
          connectionTimeout: 0,
          redeliverDelay: 0,
          retryCount: 0,
          threadCount: 0
        },
        batchSize: '1',
        timeoutSeconds: '1',
        schemas: [{
          name: '',
          content: '',
          template: '',
          groupedBy: [''],
          webhooks: []
        }]
      },
      webhooks: []
    }
  },
  created() {
    const promiseWebhooks = this.loadWebhooks()
    if (this.$route.params.id !== undefined) {
      promiseWebhooks.then(_ => {
        axios.get(process.env.ROCKET_API_URL + 'configurations/' + this.$route.params.id).then(response => {
          this.configuration = response.data

          this.configuration.schemas.forEach(function(schema) {
            if (schema.groupedBy.length === 0) {
              schema.groupedBy.push('')
            }

            schema.webhooks = schema.webhooks.map(function(w) {
              return { label: w.name, value: w }
            })
          })
        }).catch(err => {
          console.error(err)
          this.showError('Ops. Ocorreu um erro ao carregar a configuração.')
        })
      })
    }
  },
  methods: {
    addJsPathToSchema: function (schema) {
      schema.groupedBy.push('')
    },
    removeJsPathFromSchema: function (schema, path) {
      schema.groupedBy = schema.groupedBy.filter(x => x !== path)
      if (schema.groupedBy.length === 0) {
        schema.groupedBy.push('')
      }
    },
    newTab: function () {
      this.configuration.schemas.push({
        id: '',
        name: '',
        schema: '',
        template: '',
        groupedBy: [''],
        webhooks: []
      })
    },
    closeTab: function (x) {
      this.configuration.schemas.splice(x, 1)
    },
    saveConfiguration() {
      this.$validator.validateAll()
      var schemasIsValid = true

      this.configuration.schemas.forEach(function (schema, index) {
        if (this.configuration.schemas[index + 1] && (schema.content === undefined || schema.content.length <= 0)) {
          schemasIsValid = false
          this.showError('Apenas o último schema pode ficar sem conteúdo de validação.')
        }
      }.bind(this))

      if (!this.errors.any() && schemasIsValid) {
        var body = JSON.parse(JSON.stringify(this.configuration)) // Me desculpa, mas precisei fazer isso devido as referencias
        body.schemas.forEach(function(schema) {
          schema.groupedBy = schema.groupedBy.filter(path => path !== '')
          schema.webhooks = schema.webhooks.map(function(w) {
            return w.value
          })
        })

        if (this.$route.params.id !== undefined) {
          axios.put(process.env.ROCKET_API_URL + 'configurations/' + this.$route.params.id, body)
          .then(response => {
            this.showSuccess('Configuração alterada com sucesso')
            this.$router.push('/rocket')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar a configuração.')
          })
        } else {
          axios.post(process.env.ROCKET_API_URL + 'configurations', body)
          .then(response => {
            this.showSuccess('Configuração criada com sucesso')
            this.$router.push('/rocket')
          }).catch(err => {
            console.error(err)
            this.showError('Ops. Ocorreu um erro ao salvar a configuração.')
          })
        }
      }
    },
    loadWebhooks() {
      return axios.get(process.env.ROCKET_API_URL + 'webhooks').then(response => {
        this.webhooks = response.data.results.map(function (data) {
          return {
            value: data,
            label: data.name
          }
        })
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao listar os webhooks.')
      })
    }
  }
}
</script>
<style>
  .input-tag {
    color: #fff !important;
    background-color: #20a8d8 !important;
    border-color: #20a8d8 !important;
  }

  .input-tag .remove{
    color: #fff !important;
  }

  .vue-input-tag-wrapper{
    display: block !important;
    width: 100% !important;
    font-size: 0.875rem !important;
    padding: 0.5rem 1rem !important;
    line-height: 1.25 !important;
    color: #607d8b !important;
    background-color: #fff !important;
    background-image: none !important;
    background-clip: padding-box !important;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 0 !important;
    -webkit-appearance: none !important;

  }

</style>



// WEBPACK FOOTER //
// Form.vue?6a843c27